<template>
  <section id="Fest">
    <div class="d-flex justify-content-center pb-0" style="width: 100vw; margin: 0;">
      <div class="flex-center mt-0 mb-0 pb-0 " style="width: inherit;">
        <img class="p-0 mb-0" alt="Logo" src="https://b2.belca.by/images/Actions/1800х700_2.jpg" style="width: 100%;" />
      </div>
    </div>
<card class="mt-0" style="background-color: rgb(189, 225, 229); color: white; margin: 0;">
  <div class="row" >
    <div class="col-md-6 col-sm-12">
      <card-body>
        <video controls width="100%" height="700px">
          <source src="https://b2.belca.by/images/Actions/fest.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </card-body>
    </div>
    <div class="col-md-6 col-sm-12">
      <card-body>
        <card-text>
          <h5 style="color: black; text-align: center;"><b> Компания «Белый картридж» приглашает принять участие в <br />ПЕРВОМ ОТКРЫТОМ ЧЕМПИОНАТЕ «КАРТРИДЖ - НАШ ХЛЕБ».</b></h5><br />

          <span style="color: black; font-size: 1.1em;"><b>Цель мероприятия:</b> обменяться опытом, знаниями, показать себя, свои возможности и выявить лучших в нашем деле. </span><br />
          <span style="color: black; font-size: 1.1em;"><b>Участники:</b> все желающие инженеры (заправщики картриджей) сервисных центров России и Беларуси.</span><br />

          <br />
          <h5><b style="color: black; font-size: 1.1em;">Общие детали мероприятия:</b></h5><br />
          <span style="color: black; font-size: 1.1em;"><b>Место проведения</b> - сервисный центр ГК «Белый картридж», г. Минск.</span><br />
          <span style="color: black; font-size: 1.1em;"><b>Дата проведения (два дня)</b> - будет определена после регистрации большинством голосов участников.</span><br />

          <span style="color: black; font-size: 1.1em;"><b>Вступительный взнос от команды (2 участника)</b> - 15 000 RUR / 500 BYN (100 % от суммы взносов пойдут на призовой фонд). </span><br />
          <span style="color: black; font-size: 1.1em;"><b>Проживание</b> -  самостоятельно (окажем помощь в поиске вариантов, бронировании).</span><br />
          <br />
          <span style="color: black; font-size: 1.1em;">Культурно-массовые мероприятия.</span><br />
          <span style="color: black; font-size: 1.1em;">Фуршет и банкет!</span><br />
          <span style="color: black; font-size: 1.1em;">Все, что нужно взять с собой - любимый инструмент и хорошее настроение!</span> <br />
          <br />
          <span style="color: black; font-size: 1.1em;">Надеемся на активное участие команд из разных уголков России и Беларуси.</span><br />
          <br />
          <span style="color: black; font-size: 1.1em;">Наша команда приложит максимальные усилия, чтобы ПЕРВЫЙ ЧЕМПИОНАТ прошел весело, азартно и продуктивно для компаний.</span><br />
          <br />
          <span style="color: black; font-size: 1.1em;">При возникновении дополнительных вопросов просьба отправить их на <a href="mailto:open@belca.by">open@belca.by</a>, либо в группе участников <a href="https://t.me/+srHtJKB_UaRkOWIy" target="_blank">https://t.me/+srHtJKB_UaRkOWIy</a></span><br />
          <br />

          <span style="color: black; font-size: 1.1em;">В случае интереса и согласия просим пройти регистрацию в форме ниже:  </span><br />
        </card-text>
      </card-body>
    </div>
  </div>
</card>
      <row class="row">
        <column class="d-flex flex-column justify-content-center mt-2 animated slow zoomIn" md="6">
          <card class="mt-2 input-group" style="height: 150px;">
            <card-header>*Компания:</card-header>
            <card-body>
            <card-text>
                <div class="form-group">
                  <input   v-model="company" type="text" class="form-control" placeholder="Компания" required>
                </div>
              </card-text>
            </card-body>
          </card>
          <card class="mt-2 input-group" style="height: 150px;">
            <card-header >ФИО участника №1:</card-header>
            <card-body>
            <card-text>
                <div class="form-group">
                  <input v-model="fio1" type="text" class="form-control" placeholder="ФИО участника №1" required>
                </div>
              </card-text>
            </card-body>
          </card>
          <card class="mt-2 input-group" style="height: 150px;">
            <card-header>ФИО участника №2:</card-header>
            <card-body>
            <card-text>
                <div class="form-group">
                  <input v-model="fio2" type="text" class="form-control" placeholder="ФИО участника №2" required>
                </div>
              </card-text>
            </card-body>
          </card>

        </column>
        <column class="d-flex flex-column justify-content-center mt-2 animated slow zoomIn" md="6">
          <card class="mt-2 input-group" style="height: 150px;">
          <card-header >*Город:</card-header>
            <card-body>
            <card-text>
                <div class="form-group">
                  <input v-model="gorod" type="text" class="form-control" placeholder="Город" required>
                </div>
              </card-text>
            </card-body>
          </card>
          <card class="mt-2 input-group " style="height: 150px;">
          <card-header >*Контактная информация (телефон для связи): </card-header>
            <card-body>
            <card-text>
                <div class="form-group">
                  <input  v-model="contact" type="text" class="form-control" placeholder="Контактная информация (телефон для связи): " required>
                </div>
              </card-text>
            </card-body>
          </card>
          <card class="mt-2 input-group" style="height: 150px;">
            <card-header>*Удобная дата проведения фестиваля:</card-header>
            <card-body>
              <card-text>
                <div class="form-group">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input  type="radio" class="custom-control-input" id="9-10" value="9-10 января 2025 г" v-model="dateFest" required>
                    <label  class="custom-control-label" for="9-10">9-10 января 2025 г</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" id="10-11" value="10-11 января 2025 г" v-model="dateFest" required>
                    <label class="custom-control-label" for="10-11">10-11 января 2025 г</label>
                  </div>
                </div>
              </card-text>
            </card-body>
          </card>
        </column>
        <div class="d-flex justify-content-center mt-4 ml-5">
          <h6>Вопросы, помеченные * являются обязательными для заполнения</h6>
        </div>
      </row>
      <row class="row">
        <column class="d-flex justify-content-center mt-5 align-self-center animated slow zoomIn" md="12">

          <template>

            <div>
              <btn class="cyan text-white hoverable mb-5" @click.native="QuizResult()">Отправить заявку</btn>
            </div>
          </template>

        </column>
      </row>

  </section>
</template>

<script>

import { Row, Column, Btn, Card, CardBody, CardHeader, CardText } from 'mdbvue'
import ApiService from '@/services/ApiService'
import router from '@/router'

export default {
  name: 'Fest',
  components: {
    Row,
    Column,
    Btn,
    Card,
    CardBody,
    CardHeader,
    CardText
  },
  data () {
    return {
      add: '',
      company: '',
      fio1: '',
      fio2: '',
      gorod: '',
      contact: '',
      sfera: '',
      hard: '',
      concurent: '',
      dateFest: '',
      sferas: [
        'Сервис',
        'Продажи',
        'Сервис и продажи'
      ],
      concurents: [
        'Нет, берем только у вас',
        'Да, покупаем у других (ниже цена)',
        'Да, покупаем у других (шире ассортимент)',
        'Не продаем / не используем продукцию СЕТ'
      ],
      brands: [
        'Brother',
        'Canon',
        'HP',
        'Konica Minolta',
        'Kyocera Mita',
        'OKI',
        'Ricoh',
        'Samsung',
        'Xerox',
        'Epson',
        'Lexmark',
        'Pantum',
        'Sharp',
        'Triumph-Adler'],
      channels: [
        'Рассылки',
        'Сайт',
        'Telegram',
        'От менеджера'

      ],
      park: [],
      troubles: [],
      news: [],
      altnews: '',
      quiz: []
    }
  },
  methods: {
    async QuizResult () {
      this.quiz = []

      // this.quiz.push({ key: 'Компания', value: this.company })
      this.quiz.push({ key: 'id', value: this.$route.query.id })
      if (this.company !== '') this.quiz.push({ key: 'Компания', value: this.company })
      else { alert('Заполните поле Компания'); return 0 }
      if (this.gorod !== '') this.quiz.push({ key: 'Город', value: this.gorod })
      else { alert('Заполните поле Город'); return 0 }
      this.quiz.push({ key: 'Участник 1', value: this.fio1 })
      this.quiz.push({ key: 'Участник 2', value: this.fio2 })
      if (this.contact !== '') this.quiz.push({ key: 'Контакт', value: this.contact })
      else { alert('Заполните поле Контакт'); return 0 }
      if (this.dateFest !== '') this.quiz.push({ key: 'Дата', value: this.dateFest })
      else { alert('Заполните поле Дата'); return 0 }

      var file = JSON.stringify(this.quiz)
      var res = await ApiService.writeQuiz('fest', file)
      console.log('Результаты  ', this.quiz)
      console.log('Ответ сервера ', res)
      this.$dialog.alert('Ваше заявка успешно отправлена.<br> Спасибо за уделённое время!').then(function (dialog) {
        router.push('/')
      })
    }
  },
  mounted () {
    console.log(this.$route)
    console.log(this.$route.query.id)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.full {
  height: 100vh;
}

.bad-gateway-row {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 55%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.blockquote {
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/Fest.vue